import React, { useState } from 'react';
import FailedPaymentsTable from '../../components/FailedPayments/FailedPaymentsTable';
import Button from '../../components/BaseComponents/Button';
import './FailedPayments.scss';

const FailedPayments: React.FC = () => {
    const [entryCount, setEntryCount] = useState(0);
    const [reloadKey, setReloadKey] = useState(0);

    return (
        <div className='page-container'>
            <div className='failed-payments-header sideBarPad'>
                <h2 className='failed-payments-title'>Failed payments ({entryCount})</h2>
                <Button
                    onClick={() => setReloadKey((key) => key + 1)}
                    isSecondary={true}
                    variant='refresh'
                    height='40px'
                    width='40px'
                    borderRadius='10px'
                />
            </div>

            <div className='failed-payments-table-container'>
                <FailedPaymentsTable onCountUpdate={setEntryCount} reloadKey={reloadKey} />
            </div>
        </div>
    );
};

export default FailedPayments;
